module.exports = __webpack_public_path__ + "img/leftside_300.3885c145.png";